export const CategorySelectionItem = (props) => {
  const removeButton =
    props.item.price > 0 ? (
      <img
        src={props.removeImageUrl}
        style={{ cursor: "pointer", float: "right" }}
        onClick={() =>
          props.removeFromCategorySelection(props.item, props.type)
        }
        title="Odebrat z výběru"
      />
    ) : null;

  return (
    <td className={props.item.price === 0 ? "empty" : "selected"}>
      {removeButton}
      <a
        onClick={
          props.item.price === 0
            ? null
            : () => {
                openModalProductDetail(props.item.link);
              }
        }
      >
        <div
          onClick={() => props.handleClick(props.type)}
          style={{ cursor: "pointer" }}
        >
          <img
            src={props.item.thumb_image_url}
            style={{ maxHeight: 80, maxWidth: 80 }}
          />
          <p>{props.item.name}</p>
        </div>
      </a>
    </td>
  );

  function handleLinkClick(e) {
    props.removeFromCategorySelection(props.item, props.type);
  }
};
